import React from 'react';
import {Card, CardHeader, Table} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faLocationArrow,
  faPhone,
  faSortNumericDown,
  faSquare,
  faStar,
  faTruck
} from "@fortawesome/free-solid-svg-icons";
import Pickup from "../../../Models/Pickup";
import Client from "../../../Models/Client";
import Vehicle from "../../../Models/Vehicle";
import DashboardColumn from "../../../Models/DashboardColumn";
import {getAddress, getModelName} from "../../../Utils/Utils";

interface IProps  {
  pickup: Pickup;
  style?: any;
  ref?: any;
  handleClick?:(pickup:Pickup)=>void;
  columnStyle?:DashboardColumn;
}


const PickupCardComponent = ({pickup, style, ref, handleClick,columnStyle}: IProps) => {

  const getDriverOrVehicle = () => {
    if (pickup.vehicle) {
      const vehicle = pickup.vehicle as Vehicle;
      if (vehicle.driver) {
        return getModelName(vehicle.driver);
      }
      return vehicle.name;
    }
    return <b className="text-danger">
      Pendiente por asignar
    </b>;
  }

  return (
    <Card onClick={()=>handleClick && handleClick(pickup)} className="clickable pickup-card" style={{...style, marginBottom: "10px"}} ref={ref}>
      <CardHeader style={{background: columnStyle?.background || '', color: columnStyle?.textColor || ''}} >
        {
          pickup.express && <FontAwesomeIcon icon={faStar} />
        }
        &nbsp;
        {(pickup.paying_customer as Client).name} {(pickup.paying_customer as Client).last_name}
      </CardHeader>
      <Table striped size="sm" style={{marginBottom: "-1px"}}>
        <tbody>
        <tr>
          <td>
              <span className="fa-stack">
                <FontAwesomeIcon icon={faSquare} className="fa-stack-2x"/>
                <FontAwesomeIcon icon={faSortNumericDown} inverse className="fa-stack-1x"/>
              </span>
          </td>
          <td className="col-sm-10">
            Recogida: #{pickup.consecutive}
          </td>
        </tr>
        <tr>
          <td>
            <span className="fa-stack">
              <FontAwesomeIcon icon={faSquare} className="fa-stack-2x"/>
              <FontAwesomeIcon icon={faLocationArrow} inverse className="fa-stack-1x"/>
            </span>
          </td>
          <td className="col-sm-10">
            {getAddress(pickup.address)}
          </td>
        </tr>
        <tr>
          <td>
            <span className="fa-stack">
              <FontAwesomeIcon icon={faSquare} className="fa-stack-2x"/>
              <FontAwesomeIcon icon={faPhone} inverse className="fa-stack-1x"/>
            </span>
          </td>
          <td className="col-sm-10" style={{textTransform: "uppercase"}}>
            {getModelName(pickup.contact_pickup)}
          </td>
        </tr>
        {<tr>
          <td>
            <span className="fa-stack">
              <FontAwesomeIcon icon={faSquare} className="fa-stack-2x"/>
              <FontAwesomeIcon icon={faTruck} inverse className="fa-stack-1x"/>
            </span>
          </td>
          <td className="col-sm-10" style={{textTransform: "uppercase"}}>
            {
              getDriverOrVehicle()
            }
          </td>
        </tr>}
        </tbody>
      </Table>
    </Card>
  );
}
export default PickupCardComponent;
